import throttle from 'lodash.throttle';
import { useEffect, useRef, useState } from 'react';
import useDataStore from '../../../../store';
import { trendCursorValuesForGroup, trendCursorsForGroup, } from '../store';
const THROTTLE_RATE = 1000;
const noop = () => { };
export const useThrottledTrendCursorValues = ({ group, chartId, }) => {
    const [trendCursors, setTrendCursors] = useState([]);
    const [trendCursorValues, setTrendCursorValues] = useState([]);
    const handleUpdate = useRef(noop);
    useEffect(() => {
        handleUpdate.current = throttle((state) => {
            setTrendCursors(trendCursorsForGroup(group, state));
            setTrendCursorValues(trendCursorValuesForGroup(group, state));
        }, THROTTLE_RATE);
    }, [group, chartId]);
    useEffect(() => {
        useDataStore.subscribe((state) => {
            handleUpdate.current(state);
        });
    }, [group, chartId]);
    return {
        trendCursors,
        trendCursorValues,
    };
};
